module.exports = __webpack_public_path__ + "static/img/284_phase_function_Paper_PointsHejduk_Prediction.f572001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/284_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +iR+
// module chunks = 0